/** Admin-mode banner — blue stripe under the header that reminds the
 *  signed-in admin of their privileges.
 *
 *  Two variants since migration 20 split the powers:
 *   - Super admin: can edit any teammate's calendar. The "Currently
 *     editing: X" chip shows the active actAs target.
 *   - Plain admin: keeps Directory + Dashboard powers but no longer
 *     edits other people's calendars — banner text reflects that so
 *     they don't expect a behaviour the system won't allow. */
import type { JSX } from "preact";
import { state } from "../state/store";
import { displayName } from "../utils/names";

export function AdminBanner(): JSX.Element | null {
  const s = state.value;
  if (!s.isAdmin) return null;
  if (s.isSuperAdmin) {
    return (
      <div class="admin-banner">
        <span class="dot" aria-hidden="true" />
        <strong>Super admin mode</strong>
        &nbsp;— you can edit the presences, notes and meeting flags of every team member.
        {s.actAs && (
          <span class="who">
            Currently editing: <strong>{displayName(s.actAs)}</strong>
          </span>
        )}
      </div>
    );
  }
  return (
    <div class="admin-banner">
      <span class="dot" aria-hidden="true" />
      <strong>Admin mode</strong>
      &nbsp;— you can manage the Directory and view the Dashboard. Calendar editing is limited to
      your own row.
    </div>
  );
}
